import React from 'react';

import {Trend} from "../../../trend/trend";
import styles from "./game-card-odds-cell.module.scss";
import classNames from "classnames";
import {OptionCurrentRate} from "../../../option-rates/option-current-rate.js";

export const GameCardOddsCellContent = ({option, controller, betsImpressionParams, onBookieClick, bookieHrefModel}) => {
  const {type, isCurrentRateValid, trend, shouldRenderTrend} = option;

  const trendProps = {
    trend,
    shouldRenderTrend
  }

  const rateProps = {
    option,
    controller,
    betsImpressionParams,
    className: classNames(styles.cell_rate)
  }

  return (
    !isCurrentRateValid ? '-' : <>
      <div className={classNames(styles.cell_type)}>{type}</div>
      <div className={classNames(styles.cell_trend)}>
        {
          shouldRenderTrend ? <Trend {...trendProps}/> : '-'
        }
      </div>
      <OptionCurrentRate {...rateProps}/>
    </>
  )
};
